export function  createPeerConnection() {
    return new RTCPeerConnection({
        iceServers: [
            { urls: 'stun:stun.cloudflare.com:3478' },
            { urls: 'stun:stun.l.google.com:19302' },
            { urls: 'stun:stun1.l.google.com:19302' },
        ],
        bundlePolicy: 'max-bundle',
    });
}

export function ensureArray<T>(data: T): T {
    if (Array.isArray(data)) {
        return data;
    } else if (data && typeof data === 'object') {
        return Object.values(data) as T;
    }
    return [] as T;
}